import { render } from "./IndexPage.vue?vue&type=template&id=78048c48&ts=true"
import script from "./IndexPage.vue?vue&type=script&lang=ts"
export * from "./IndexPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/tecnonet/app.galidancia.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__